import { ApplicationProductName } from 'enums/common.enums';
import { Lender, LoanTerm } from 'enums/ApplicationsVariables';
import { OptionType } from 'utils/inputSelect';
import { hilAutomatedOffersApi } from 'api/AutomatedOffersApi';
import { posAutomatedOffersApi } from 'api/SmallLoanProgram/AutomatedOffersApi';
import { offersApi } from 'api/OffersApi';

import {
  MAX_LOAN_AMOUNT_RANGE,
  MIN_LOAN_AMOUNT_RANGE,
  MAX_LOAN_AMOUNT_FOR_SMALL_LOAN_PROGRAM,
  MIN_LOAN_AMOUNT_FOR_SMALL_LOAN_PROGRAM,
  LOAN_TERM_CHANGES_ALLOWED_STATUSES,
  LOAN_TERM_CHANGES_ALLOWED_STATUSES_FOR_SMALL_LOAN_PROGRAM,
} from './UpdateLoanTerms/updateLoanTerms.constants';
import { GetOfferApiParams } from './acceptOfferDetails.types';
import { POS_TERMS_BY_LENDER, THIRTY_YEARS_TERM_MIN_VANTAGE_SCORE } from './acceptOfferDetails.constants';

export const getMaxLoanAmount = (productName: string) => {
  switch (true) {
    case productName === ApplicationProductName.SmallLoanProgram:
      return MAX_LOAN_AMOUNT_FOR_SMALL_LOAN_PROGRAM;
    default:
      return MAX_LOAN_AMOUNT_RANGE;
  }
};

export const getMinLoanAmount = (productName: string) => {
  switch (true) {
    case productName === ApplicationProductName.SmallLoanProgram:
      return MIN_LOAN_AMOUNT_FOR_SMALL_LOAN_PROGRAM;
    default:
      return MIN_LOAN_AMOUNT_RANGE;
  }
};

export const getAllowedStatuses = (productName: string) => {
  switch (true) {
    case productName === ApplicationProductName.SmallLoanProgram:
      return LOAN_TERM_CHANGES_ALLOWED_STATUSES_FOR_SMALL_LOAN_PROGRAM;
    default:
      return LOAN_TERM_CHANGES_ALLOWED_STATUSES;
  }
};

export const getLoanTerms = (
  productName: string,
  lender: Lender,
  vantageScore: number,
  minLoanTerm?: LoanTerm,
): OptionType[] => {
  const allowedTerms: LoanTerm[] =
    productName === ApplicationProductName.HomeImprovementLoan
      ? [
          ...(lender === Lender.Lfcu ? [LoanTerm.ThreeYears] : []),
          LoanTerm.SevenYears,
          LoanTerm.TenYears,
          LoanTerm.FifteenYears,
          LoanTerm.TwentyYears,
          ...(lender === Lender.SeattleBank && vantageScore >= THIRTY_YEARS_TERM_MIN_VANTAGE_SCORE
            ? [LoanTerm.ThirtyYears]
            : []),
        ]
      : (POS_TERMS_BY_LENDER[lender] ?? []);

  if (minLoanTerm) {
    const minTerm = parseInt(minLoanTerm, 10);

    return Object.values(allowedTerms)
      .map((term) => ({ value: term, label: `${term} years` }))
      .filter(({ value }) => parseInt(value, 10) >= minTerm);
  }

  return Object.values(allowedTerms).map((term) => ({ value: term, label: `${term} years` }));
};

export function getOfferApi({ productName, hasAutomatedOffer }: GetOfferApiParams) {
  if (productName === ApplicationProductName.SmallLoanProgram) {
    return posAutomatedOffersApi;
  }

  if (hasAutomatedOffer) {
    return hilAutomatedOffersApi;
  }

  return offersApi;
}
